import { observable, action } from "mobx";

class ReconnectLiSequenceLoadingPopupState {
  @observable showPopup = false;
  @observable loadingData = {};

  @action
  setData = (val = {}) => {
    this.loadingData = val;
  };

  @action
  setShowPopup = (val = false) => {
    this.showPopup = val;
    if (val) {
      document.getElementsByTagName("body")[0].classList.add("scrollHidden");
    } else {
      this.setData({});
      document.getElementsByTagName("body")[0].classList.remove("scrollHidden");
    }
  };
}

const reconnectLiSequenceLoadingPopupState = new ReconnectLiSequenceLoadingPopupState();

export { reconnectLiSequenceLoadingPopupState };
export default reconnectLiSequenceLoadingPopupState;
